// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__uxs4M","title":"index_title__t29oT","desc":"index_desc__Q0Y6z","list":"index_list__ixzKH","card":"index_card__jPwtS"};